import { CreateSingleReport } from '../../models';
import { SectionHeader, SectionSubHeader } from '../Card';
import ReportGrid from './ReportGrid';

type SingleVariableReportProps = {
  singleReport: CreateSingleReport | undefined;
};

export function SingleVariableReport({ singleReport }: SingleVariableReportProps) {
  return (
    <>
      <SectionHeader>Aggregate Information</SectionHeader>
      <SectionSubHeader></SectionSubHeader>
      <ReportGrid data={singleReport}></ReportGrid>
    </>
  );
}

export default SingleVariableReport;
